import React, { Fragment, useState, useEffect } from "react";

import { useTranslation } from "react-i18next";

import { Listbox, Transition } from "@headlessui/react";
import { Caret } from "@routes/IconeSvg";

import Badge from "./Badge";
import CheckboxSimple from "./CheckboxSimple";
import DisclosureListbox from "./DisclosureListbox";
import Divider from "./Divider";
import LinkButton from "./LinkButton";
import ResetFilter from "./ResetFilter";

/**
 * @typedef {Object} Props
 * @property {string} label
 * @property {Array<any>} dataList
 * @property {any=} dataSelected
 * @property {((e: any) => void)=} handleSelect
 * @property {(e: any) => void} selectAll
 * @property {string=} placeholder
 */

/**
 *
 * @param {Props} props
 * @returns
 */
export default function ListboxCollapse(props) {
  const {
    label,
    dataList,
    dataSelected,
    handleSelect,
    selectAll,
    placeholder,
  } = props;

  const { t } = useTranslation("pages.employés.exportation");
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    setSelected(dataSelected);
  }, [dataSelected]);

  const resetFilter = (ev) => {
    ev.stopPropagation();

    setSelected([]);
    handleSelect([]);
  };
  return (
    <Listbox
      value={selected}
      onChange={(e) => {
        setSelected(e);
        handleSelect(e);
      }}
      name="listBoxCollapse"
      multiple
    >
      {({ open }) => (
        <div className="arh-relative arh-w-full">
          <Listbox.Label className="arh-mb-1 arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor">
            {t(label)}
          </Listbox.Label>
          <Listbox.Button className="arh-relative arh-h-11 arh-w-full arh-cursor-default arh-rounded arh-border arh-border-solid arh-border-[#ECECEC] arh-bg-white arh-py-3 arh-pl-6 arh-pr-[92px] arh-text-left arh-font-poppins arh-text-xs arh-font-normal placeholder:arh-text-[#8B8F91] focus:arh-outline-none focus-visible:arh-border-[#ECECEC] focus-visible:arh-ring-2 focus-visible:arh-ring-[#ECECEC] focus-visible:arh-ring-opacity-75 focus-visible:arh-ring-offset-2 focus-visible:arh-ring-offset-greyColor">
            {selected.length > 0 && (
              <ResetFilter onClick={(e) => resetFilter(e)} />
            )}
            {/* <span className="arh-block arh-truncate arh-max-w-[12rem] arh-text-ellipsis">
              {selected.length > 0
                ? selected
                  .map((item) => item.name || item.title || item.label)
                  .join(", ")
                : placeholder}
            </span> */}
            <input
              className="arh-ml-2 arh-block arh-w-full arh-max-w-full arh-truncate arh-text-ellipsis arh-border-0 arh-text-darkColor placeholder:arh-text-[#8B8F91]"
              type="text"
              placeholder={placeholder}
              defaultValue={
                selected.length > 0
                  ? selected
                      .map((item) => t(item.name || item.title || item.label))
                      .join(", ")
                  : ""
              }
            />
            {selected.length > 0 && (
              <span className="arh-pointer-events-none arh-absolute arh-inset-y-0 arh-right-0 arh-flex arh-items-center arh-pr-10">
                <Badge
                  bgColor="arh-bg-[#E6F8EF]"
                  textColor="arh-text-[#295143]"
                  text={selected.length.toString()}
                />
              </span>
            )}
            <span className="arh-pointer-events-none arh-absolute arh-inset-y-0 arh-right-0 arh-flex arh-items-center arh-pr-18">
              <Caret
                className={`${open ? "arh-rotate-90" : "arh-rotate-0"}`}
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="arh-transition arh-ease-in arh-duration-100"
            leaveFrom="arh-opacity-100"
            leaveTo="arh-opacity-0"
          >
            <Listbox.Options className="arh-absolute arh-z-20 arh-mt-1 arh-max-h-60 arh-w-full arh-overflow-y-auto arh-overflow-x-hidden arh-rounded arh-bg-white arh-px-4 arh-py-6 arh-text-xs arh-shadow-xs">
              {dataList?.map((data) => (
                <DisclosureListbox key={data.id} label={t(data.label)}>
                  {data.data.map((item) => (
                    <Listbox.Option
                      key={item.id}
                      className="arh-relative arh-cursor-pointer arh-select-none arh-list-none arh-truncate arh-font-poppins arh-text-xs arh-font-normal arh-text-darkColor"
                      value={item}
                    >
                      {({ selected }) => (
                        <>
                          {/*
                           * Use CheckboxStatus component for dropdown that contains status items
                           * Ex : Actif, Temporairement inactif, etc...
                           */}

                          <CheckboxSimple
                            id={item.id}
                            name="item"
                            label={t(item.name || item.title || item.label)}
                            checked={selected}
                          />
                        </>
                      )}
                    </Listbox.Option>
                  ))}
                </DisclosureListbox>
              ))}
              <Divider />
              <LinkButton
                label={t("Tout séléctionner")}
                textColor="arh-text-[#388879]"
                onClick={selectAll}
              />
            </Listbox.Options>
          </Transition>
        </div>
      )}
    </Listbox>
  );
}
